// @ts-nocheck
import React, { memo } from "react";
import { back_icon, noti_icon, profile_img } from "../../assets/img";
import { useLocation, useNavigate } from "react-router-dom";

const Topbar = ({ header, subHead, back }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const type = location?.state?.type;

  console.log("type", type);
  const adminDetails = JSON.parse(localStorage.getItem("admin_details"));
  console.log("adminDetails", adminDetails);

  return (
    <div className="d-flex ac-jb topbar mb-4 pb-1 mt-3">
      <div className="">
        <div className="d-flex ac-js gap-2">
          {type === "view" || type === "edit" || type === "add" || back ? (
            <img
              src={back_icon}
              onClick={() => {
                navigate(-1);
              }}
              className="back-arrow"
              alt=""
            />
          ) : (
            ""
          )}
          <h2 className=" f-w600 f3 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24 ">
            {header}
          </h2>
        </div>
        <p className=" f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 sec mt-2">
          {subHead}
        </p>
      </div>
      <div className="d-flex ac-jc">
        <img src={noti_icon} className="noti-icon pointer" alt="" />
        <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0 ps-2 py-3 sec">
          Hello,{" "}
          <span className="primary">
            {adminDetails?.name
              ? adminDetails.name.charAt(0).toUpperCase() +
                adminDetails.name.slice(1).toLowerCase()
              : ""}
          </span>
        </p>
        <img src={profile_img} className="profile-img pointer" alt="" />
      </div>
    </div>
  );
};

export default memo(Topbar);
